var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
export default class ProgramService {
    static getPrograms(search = {}, pageSize = 20, page = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            let response;
            if (search.active == null) {
                response = yield apiClient.get("/programs/search/findByNameContainingIgnoreCaseOrAcronymContainingIgnoreCase", {
                    params: {
                        name: search.query,
                        acronym: search.query,
                        pageSize,
                        page,
                        sort: search.sort
                            ? `${search.sort},${search.sortDirection || "asc"}`
                            : "name,asc",
                        active: null,
                    },
                });
            }
            else {
                response = yield apiClient.get("/programs/search/searchByNameAcronymAndActive", {
                    params: {
                        name: search.query,
                        acronym: search.query,
                        active: search.active,
                        sort: search.sort
                            ? `${search.sort},${search.sortDirection || "asc"}`
                            : "name,asc",
                        pageSize,
                        page,
                    },
                });
            }
            return {
                programs: response.data._embedded.programs,
                pageInfo: response.data.page,
            };
        });
    }
    static findAllById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            // fetch the specific programs from the API
            const apiClient = getApiClient();
            const response = yield apiClient.get(`/programs/search/findByIdIn?ids=${ids.join(",")}`);
            return response.data._embedded.programs;
        });
    }
    static searchPrograms(query, max = 50) {
        return FetchService.get("/aviso/program/searchAsJson", {
            q: query,
            max,
        });
    }
}
